import { render, staticRenderFns } from "./user-rank.vue?vue&type=template&id=5050aa07&scoped=true&"
import script from "./user-rank.vue?vue&type=script&lang=js&"
export * from "./user-rank.vue?vue&type=script&lang=js&"
import style0 from "./user-rank.vue?vue&type=style&index=0&id=5050aa07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5050aa07",
  null
  
)

export default component.exports